import QuestionnaireScheduleFrequencySelect from '../Modules/Base/Components/Inputs/QuestionnaireScheduleFrequencySelect/QuestionnaireScheduleFrequencySelect';
import HealthCareRegulationCaseTypeSelectField from '../Modules/Base/Components/Inputs/HealthInsuranceCompanySelect/HealthInsuranceCompanySelectField';

export enum MagicField {
	TEXT = 'text',
	IMAGE = 'image',
	TEXT_FIELD = 'textfield',
	MULTIPLIER = 'multiplier',
	MULTIPLIER_REMOVE_BUTTON = 'multiplier_remove_button',
	TEXTAREA = 'textarea',
	SELECT = 'select',
	NUMBER = 'number',
	RADIOLIST = 'radio_list',
	CHECKBOX = 'checkbox',
	TITLE = 'title',
	COLLAPSE = 'collapse',
	LABEL = 'label',
	HR = 'hr',
	CUSTOMTEXT = 'customtext',
	BLOODPRESSURE = 'bloodpressure',
	GLYCAEMIA = 'glycaemia',
	GLUCOSE = 'glucose',
	DIAGNOSIS_LATAM = 'diagnosis_latam',
	BMI = 'bmi',
	SUBMIT = 'submit',
	CONDITION = 'condition',
	CONTAINER = 'container',
	HSTACK = 'hstack',
	HIDDEN = 'hidden',
	WHITESPACE = 'white_space',
	QUESTIONNAIRE_SELECT = 'questionnaire_select',
	PATIENT_SELECT = 'patient_select',
	DOCTOR_SELECT = 'doctor_select',
	TIMEPICKER = 'timepicker',
	DATEPICKER = 'datepicker',
	NZCI_VACCINATION_KIND = 'nczi_vaccination_kind',
	NZCI_VACCINATION_TYPE = 'nczi_vaccination_type',
	NZCI_SPECIALIZATION = 'nczi_specialization',
	ORGANIZATION_UNIT_SELECT = 'organization_unit_select',
	PRICE_WITH_CURRENCY = 'price_with_currency',
	PHONE_NUMBER = 'phoneNumber',
	EMAIL = 'email',
	RICH_TEXT_FIELD = 'richTextField',
	DIAGNOSIS_CZECH = 'diagnosis_czech',
	VZP_REIMBURSEMENT = 'vzp_reimbursement',
	CASE_TYPE_REGULATION = 'case_type_regulation',
	QUESTIONNAIRE_SCHEDULE_FREQUENCY = 'questionnaire_schedule_frequency',
	FIELD_OF_CARE_SUKL_SELECT = 'field_of_care_sukl_select',
	FORM_OF_CARE_SELECT = 'form_of_care_select',
	CITIZENSHIP_SELECT = 'citizenship_select',
	HEALTH_INSURANCE_COMPANY_SELECT = 'health_insurance_company_select',
	GENDER = 'gender',
	WORKPLACE_SELECT = 'workplace_select',
	PATIENT_CONSENT_REQUEST = 'patient_consent_request',
	SUKL_MEDICAMENT_SELECT = 'sukl_medicament_select',
	TRANSLATIONS = 'translations',
	VAT_RATE = 'vat_rate',
	ROLE_MULTISELECT_WITH_CHECKLIST = 'role_multiselect_with_checklist',
	P1_MEDICAMENT = 'p1_medicament',
	P1_PAYMENT_COVERAGE_TYPE = 'p1_payment_coverage_type',
	P1_DOSAGE_INTERVAL_TYPE = 'p1_dosage_interval_type',
}
